import { LineObject } from "../../data/models/LineObject.js";
import { findNearestLineCut } from "../../geometry/hitTesting.js";
import { BaseTool } from "../BaseTool.js";
import { createStyledDot, isPrimaryPointer } from "../toolHelpers.js";

export class CutLineTool extends BaseTool {
  constructor() {
    super("cut-line");
  }

  onPointerDown(context) {
    if (!isPrimaryPointer(context)) {
      return;
    }

    context.clearPreview();

    const cut = findNearestLineCut({
      documentModel: context.getDocument(),
      screenPoint: context.screenPoint,
      viewport: context.viewport,
      tolerance: context.config.tools.lineCutTolerance
    });

    if (!cut) {
      return;
    }

    const cutDot = createStyledDot(context, cut.projectionWorld, "cut-point");
    const [startPointId, endPointId] = cut.object.points;
    const firstSegment = createSegment(context, cut.object, [startPointId, cutDot.id], "segment-1");
    const secondSegment = createSegment(context, cut.object, [cutDot.id, endPointId], "segment-2");

    context.dataManager.replaceObject(cut.object.id, [firstSegment, secondSegment]);
    context.render();
  }
}

function createSegment(context, originalLine, points, prefix) {
  return new LineObject({
    ...originalLine,
    id: context.dataManager.createUniqueObjectId(`${originalLine.id ?? "line"}-${prefix}`),
    points,
    dimensions: []
  });
}
